exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#medication-doses{color:#333}#medication-doses .item-flex-right{display:none}#medication-doses ul.no-data li{padding:20px;color:#4f4f4f;font-size:14px}#medication-doses .time-of-day{display:block;font-size:16px;padding:20px 20px 10px 20px;border-bottom:1px solid #e0e0e0}#medication-doses .day-container .overdue-label{color:#cf4845;display:flex;align-items:center;font-size:14px}#medication-doses .day-container .overdue-label svg{width:16px;margin-right:4px}#medication-doses .day-container .takeNow-label{color:#54c2b6;display:flex;align-items:center;font-size:14px}#medication-doses .day-container .takeNow-label svg{width:16px;margin-right:4px}#medication-doses .day-container figure{border-radius:18px;height:36px;width:36px;display:flex;align-items:center;justify-content:center;color:#333}#medication-doses .day-container .list-view-noData{float:right;margin-right:20px;margin-top:-80px}#medication-doses .day-container .no-medication-div{text-align:center;margin:30px 0}#medication-doses .day-container .no-medication-div .no-med-img{width:100px;margin:15px 30px}#medication-doses .day-container .message{color:#049fda;font-size:14px}#medication-doses .day-container .upcoming-date{font-size:14px;font-family:700}#medication-doses .day-container .med-taken{fill:#54c2b6 !important;margin-left:10px;margin-top:10px}#medication-doses .day-container .med-skipped{fill:#828282 !important;margin-left:9px;margin-top:1px;width:19px;margin-right:6px}#medication-doses .day-container .med-status{display:flex;justify-content:space-between}#medication-doses .day-container .med-status .med-status-timing{font-weight:500;margin-right:20px}#medication-doses .day-container .med-status .medicine-name{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}#medication-doses .day-container .current-date-label{text-align:center;padding:15px 15px 0;font-family:700}#medication-doses .medication-action{padding:10px;display:flex;align-items:center;justify-content:center;border-top:1px solid #e0e0e0}#medication-doses .buttonGroup .takeButton,#medication-doses .buttonGroup .skipButton{color:#0a99c5;padding:15px;font-size:16px;width:50%}#medication-doses .buttonGroup .skipButton{color:#4f4f4f;border-right:1px solid #e0e0e0}#medication-doses button:hover{cursor:pointer}#medication-doses li.card-list-item{border-bottom:1px solid #e0e0e0;box-shadow:none}#medication-doses li.card-list-item:last-child{border:0}", ""]);

// Exports
exports.locals = {
	"colorTeal": "#54c2b6",
	"colorViolet": "#727cf5",
	"colorTealRedChannel": "84",
	"colorTealGreenChannel": "194",
	"colorTealBlueChannel": "182",
	"colorTealDark": "#26a995",
	"colorTeal50": "rgba(84,194,182,.5)",
	"colorTealScreened": "#54c2b6",
	"colorWhiteOff": "#f2f2f2",
	"colorWhite": "#fff",
	"colorWhiteTrans": "rgba(255,255,255,0)",
	"colorWhite50": "rgba(255,255,255,.5)",
	"colorWarning": "#ea3030",
	"colorWarningLight": "rgba(234,48,48,.15)",
	"colorBlack": "#333",
	"colorGrayDark": "#4f4f4f",
	"colorGray": "#828282",
	"colorGrayLight": "#e0e0e0",
	"colorGrayLight60": "rgba(224,224,224,.6)",
	"colorBlue": "#049fda",
	"colorBlackDark": "#242424",
	"ColorText": "#474747",
	"colorBlueScreened": "#049fda",
	"colorMagenta": "#ea3b7d",
	"colorMagentaScreened": "#ea3b7d",
	"colorYellow": "#fed504",
	"colorYellowDark": "#d8b129",
	"colorYellowScreened": "#fed504",
	"colorUi1": "rgba(4,159,218,.3)",
	"colorUi2": "rgba(84,194,182,.3)",
	"colorUi3": "rgba(234,59,125,.3)",
	"colorUi4": "rgba(254,213,4,.3)",
	"colorUi5": "rgba(31,79,228,.3)",
	"colorUi6": "rgba(177,208,21,.3)",
	"colorUi7": "rgba(228,34,255,.3)",
	"colorUi8": "rgba(255,157,39,.3)",
	"colorUi9": "rgba(66,32,208,.3)",
	"colorUi10": "rgba(26,255,198,.3)",
	"colorUi11": "rgba(205,38,26,.3)",
	"colorUi12": "rgba(247,184,50,.3)",
	"colorUi13": "rgba(146,79,207,.3)",
	"colorUi14": "rgba(98,205,36,.3)",
	"colorUi15": "rgba(255,24,9,.3)",
	"colorUi16": "rgba(207,111,79,.3)",
	"chartLightYellow": "rgba(252,215,34,.7)",
	"chartLightPink": "rgba(250,92,124,.7)",
	"chartLightBlue": "rgba(57,175,209,.7)",
	"fontStyleNormal": "\"robotoregular\",sans-serif"
};